var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLocationCrossIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "currentColor",
    viewBox: "0 0 16 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0a.999.999 0 0 1 1 1v1.0844C11.5125 2.503 13.4969 4.4875 13.9156 7H15a.999.999 0 0 1 1 1 .999.999 0 0 1-1 1h-1.0844c-.4187 2.5125-2.4031 4.4969-4.9156 4.9156V15a.999.999 0 0 1-1 1 .999.999 0 0 1-1-1v-1.0844C4.4875 13.4969 2.5031 11.5125 2.0844 9H1a.999.999 0 0 1-1-1c0-.5531.4469-1 1-1h1.0844C2.503 4.4875 4.4875 2.5031 7 2.0844V1c0-.5531.4469-1 1-1M4 8a3.9999 3.9999 0 0 0 6.8284 2.8284 3.9996 3.9996 0 0 0 0-5.6568A3.9999 3.9999 0 0 0 4 8m4-2.5a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLocationCrossIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/location-cross-icon.01e0200ca722218c63db6f9dd6afdc14.svg";